import _slicedToArray from "/root/website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import { dispatchInputChange } from './dispatchNativeEvent';
var Types;

(function (Types) {
  Types["TEXT"] = "text";
  Types["PASSWORD"] = "password";
})(Types || (Types = {}));

var useInputOpened = function useInputOpened(_ref) {
  var value = _ref.value,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? Types.TEXT : _ref$type,
      loading = _ref.loading,
      cleanable = _ref.cleanable,
      onChange = _ref.onChange;

  var _React$useState = React.useState(value || ''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      text = _React$useState2[0],
      setText = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showEraseButton = _React$useState4[0],
      setShowEraseButton = _React$useState4[1];

  var _React$useState5 = React.useState(type),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      currentType = _React$useState6[0],
      setCurrentType = _React$useState6[1];

  var inputRef = React.useRef();

  var handleEraseButton = function handleEraseButton() {
    var _inputRef$current;

    var EMPTY = '';
    setText(EMPTY);
    dispatchInputChange(inputRef.current, EMPTY);
    (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.focus == null ? void 0 : _inputRef$current.focus();
  };

  var handleEyeButton = function handleEyeButton() {
    setCurrentType(currentType === Types.PASSWORD ? Types.TEXT : Types.PASSWORD);
  };

  var handleOnChange = function handleOnChange(e) {
    e.preventDefault();
    onChange == null ? void 0 : onChange(e);
    setText(e.currentTarget.value);
  };

  var updateShowEraseButton = React.useCallback(function (field) {
    return setShowEraseButton(Boolean(!loading && type !== Types.PASSWORD && cleanable && field.length > 0));
  }, [cleanable, loading, type]);

  var showEyeButton = function showEyeButton() {
    return type === Types.PASSWORD && !loading;
  };

  React.useEffect(function () {
    updateShowEraseButton(value || text);
  }, [value, text, updateShowEraseButton]);
  return {
    showEyeButton: showEyeButton,
    handleOnChange: handleOnChange,
    handleEyeButton: handleEyeButton,
    handleEraseButton: handleEraseButton,
    showEraseButton: showEraseButton,
    text: text,
    currentType: currentType,
    inputRef: inputRef
  };
};

export { useInputOpened, Types };